import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_HOMEPAGE_SUPPORT_AWARENESS = createFcmDetails('homepage_support_awareness', {
	owner: 'Starter Growth',
	context: 'homepage',
	description: 'Used to enable the support awareness component on the homepage.',
	import: false,
	template: {
		title: 'Our petition experts are waiting to support you',
		content:
			'Our team of petition experts are live now, ready to look at your petition and give you personalized advice over SMS.',
		locales: ['en-US'],
	},
});
